//
//
//
//
//
//

export default {
  data () {
    return {
      flags: false,
      position: {
        x: 0,
        y: 0
      },
      nx: '',
      ny: '',
      dx: '',
      dy: '',
      styleLeft: '',
      styleTop: '',
      moveBtn: {}
    }
  },
  mounted () {
    this.moveBtn = this.$refs.moveBtn
  },
  methods: {
    toPage () {
      this.$store.commit('payParams/isClickParklot', true)
      this.$router.push('toggleParklot')
    },
    // 实现移动端拖拽
    down () {
      this.flags = true
      let touch
      if (event.touches) {
        touch = event.touches[0]
      } else {
        touch = event
      }
      this.position.x = touch.clientX
      this.position.y = touch.clientY
      this.dx = this.moveBtn.offsetLeft
      this.dy = this.moveBtn.offsetTop
    },
    move () {
      if (this.flags) {
        let touch
        if (event.touches) {
          touch = event.touches[0]
        } else {
          touch = event
        }
        this.nx = touch.clientX - this.position.x
        this.ny = touch.clientY - this.position.y
        this.styleLeft = this.dx + this.nx
        this.styleTop = this.dy + this.ny
        let clientWidth = document.documentElement.clientWidth
        let clientHeight = document.documentElement.clientHeight
        if (
          this.styleLeft > 0 &&
          this.styleLeft < clientWidth - this.moveBtn.offsetWidth
        ) {
          this.moveBtn.style.left = this.styleLeft + 'px'
        }
        if (
          this.styleTop > 0 &&
          this.styleTop < clientHeight - this.moveBtn.offsetHeight
        ) {
          this.moveBtn.style.top = this.styleTop + 'px'
        }
        // 阻止页面的滑动默认事件
        document.addEventListener('touchmove', this.handler, {
          passive: false
        })
      }
    },
    // 鼠标释放时候的函数
    end () {
      this.flags = false
      document.addEventListener('touchmove', this.handler, {
        passive: false
      })
    },
    handler () {
      if (this.flags) {
        event.preventDefault()
      } else {
        return true
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ToggleBtn.vue